import { useEffect, useState } from "react";
import SummaryApi from "../../common";
import { Pencil, TruckElectric } from "lucide-react";

function YatraList() {
  const [yatras, setYatras] = useState([]);
  const [selectedYatra, setSelectedYatra] = useState(null);
  const [varkaris, setVarkaris] = useState([]);
  const [editIndex, setEditIndex] = useState(null);
  const [newAmount, setNewAmount] = useState(" ");
  const [railwayTicket, setRailwayTicket] = useState(0);
  const [busTicket, setBusTicket] = useState(0);
  const [kirana, setKirana] = useState(0);
  const [roomhotel, setroomhotel] = useState(0);
  const [otherexpense, setotherexpense] = useState(0);
  const [showVarkariModal, setShowVarkariModal] = useState(false);
  const [showAddModal, setShowAddModal] = useState(false);
  const [allvarkaris, setallVarkaris] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedVarkariIds, setSelectedVarkariIds] = useState([]);

  const [newVarkari, setNewVarkari] = useState({
    name: "",
    age: "",
    mobileNo: "",
    aadharCardNo: "",
    address: "",
    apang: false,
    agreedTerms: true,
  });

  const handleCreateVarkari = async () => {
    if (!newVarkari.agreedTerms) {
      alert("कृपया अटी व शर्ती स्वीकारा.");
      return;
    }

    try {
      const response = await fetch(SummaryApi.createVarkari.url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          ...newVarkari,
          yatraId: selectedYatra._id,
          yatraName: selectedYatra.yatraName,
          price: selectedYatra.pricePerPerson,
          booking: "Accepted",
        }),
      });

      const result = await response.json();

      if (!response.ok) {
        alert("वारकरी तयार करताना त्रुटी: " + (result.error || result.message));
        return;
      }

      // Success
      setShowVarkariModal(false);
      setNewVarkari({
        name: "",
        age: "",
        mobileNo: "",
        aadharCardNo: "",
        address: "",
        apang: false,
        agreedTerms: true,
      });

      // Update list
      setVarkaris((prev) => [...prev, result.varkari]);
    } catch (err) {
      alert("Server Error: " + err.message);
    }
  };

  useEffect(() => {
    if (selectedYatra?.financialSummary) {
      const summary = selectedYatra.financialSummary;
      setRailwayTicket(summary.railwayTicket || 0);
      setBusTicket(summary.busTicket || 0);
      setKirana(summary.kirana || 0);
      setroomhotel(summary.roomhotel || 0);
      setotherexpense(summary.otherexpense || 0);
    }
  }, [selectedYatra]);

  useEffect(() => {
    const fetchYatras = async () => {
      try {
        const response = await fetch(SummaryApi.getAllYatra.url, {
          method: "GET",
          headers: { "Content-Type": "application/json" },
        });
        const data = await response.json();
        if (Array.isArray(data)) {
          setYatras(data);
        } else {
          console.warn("Unexpected response structure:", data);
        }
      } catch (error) {
        console.error("Error fetching yatras:", error);
      }
    };

    fetchYatras();
  }, []);

  const formatDate = (date) =>
    new Intl.DateTimeFormat("en-GB").format(new Date(date));

  const handleClick = async (yatra) => {
    setSelectedYatra(yatra);

    try {
      const response = await fetch(
        `${SummaryApi.getVarkarisByYatraId.url}/${yatra._id}`,
        {
          method: "GET",
          headers: { "Content-Type": "application/json" },
        }
      );
      const data = await response.json();

      if (Array.isArray(data)) {
        setVarkaris(data);
      } else {
        console.warn("Unexpected Varkari response:", data);
        setVarkaris([]);
      }
    } catch (error) {
      console.error("Error fetching varkari list:", error);
      setVarkaris([]);
    }
  };

  const handleSaveAmount = async (varkariId, yatraId, amount) => {
    try {
      const res = await fetch(SummaryApi.updatePaidAmount.url, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ varkariId, yatraId, newAmount: amount }),
      });

      if (res.ok) {
        alert("रक्कम यशस्वीरित्या अपडेट झाली");
        setEditIndex(null);

        // Update local state instantly
        setVarkaris((prev) =>
          prev.map((v) =>
            v._id === varkariId
              ? {
                  ...v,
                  yatra: v.yatra.map((y) =>
                    y.yatraId === yatraId || y.yatraId?._id === yatraId
                      ? { ...y, paidAmount: Number(amount) }
                      : y
                  ),
                }
              : v
          )
        );
      } else {
        alert("अपडेट करताना त्रुटी आली");
        console.log("Sending:", { varkariId, yatraId, newAmount: amount });
      }
    } catch (err) {
      alert("सर्व्हर एरर");
    }
  };

  const handleBack = () => {
    setSelectedYatra(null);
  };

  const filteredVarkaris = selectedYatra
    ? varkaris
        .filter((v) =>
          v.yatra.some(
            (y) =>
              (y.yatraId === selectedYatra._id ||
                y.yatraId?._id === selectedYatra._id) &&
              y.booking === "Accepted"
          )
        )
        .map((varkari) => {
          const currentYatra = varkari.yatra.find(
            (y) =>
              y.yatraId === selectedYatra._id ||
              y.yatraId?._id === selectedYatra._id
          );
          const price = currentYatra?.price ?? 0;
          const paid = currentYatra?.paidAmount ?? 0;
          const baki = price - paid;

          return { varkari, price, paid, baki, currentYatra };
        })
    : [];

  const totalPrice = filteredVarkaris.reduce((sum, v) => sum + v.price, 0);
  const totalPaid = filteredVarkaris.reduce((sum, v) => sum + v.paid, 0);
  const totalBaki = filteredVarkaris.reduce((sum, v) => sum + v.baki, 0);

  const saveFinancialData = async () => {
    const payload = {
      railwayTicket,
      busTicket,
      kirana,
      roomhotel,
      otherexpense,
      totalammount: totalPrice,
      totalCollectedAmount: totalPaid,
    };

    try {
      const response = await fetch(
        `${SummaryApi.saveFinancialSummary.url}/${selectedYatra._id}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        }
      );

      if (response.ok) {
        // Show success message (optional toast if you're using react-toastify)
        alert("आर्थिक सारांश जतन झाला.");
        window.location.reload();
      } else {
        alert("काहीतरी चूक झाली.");
      }
    } catch (error) {
      console.error(error);
      alert("सर्वर एरर.");
    }
  };

  const handleRemoveVarkari = async (varkariId, yatraId) => {
    if (!window.confirm("तुम्हाला हे वारकरी यात्रा मधून काढायचे आहे का?"))
      return;

    try {
      // 🔧 Call your backend API here
      const response = await fetch(SummaryApi.removeYatraFromVarkari.url, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ varkariId, yatraId }),
      });

      const result = await response.json();

      if (response.ok) {
        // ✅ Re-fetch or update state
        alert("वारकरी यशस्वीरित्या काढण्यात आले.");
        // Optionally update local state:
        setVarkaris((prev) =>
          prev.map((v) =>
            v._id === varkariId
              ? {
                  ...v,
                  yatra: v.yatra.filter(
                    (y) => y.yatraId !== yatraId && y.yatraId?._id !== yatraId
                  ),
                }
              : v
          )
        );
      } else {
        alert(result.message || "काहीतरी चूक झाली.");
      }
    } catch (error) {
      console.error("Remove error:", error);
      alert("वारकरी काढता आले नाही.");
    }
  };

  const fetchVarkaris = async () => {
    setLoading(true);
    try {
      const response = await fetch(SummaryApi.getAllVarkaris.url);
      const data = await response.json();
      setallVarkaris(data);
    } catch (error) {
      console.error("Error fetching Varkaris:", error);
    } finally {
      setLoading(false);
    }
  };

  const openModal = () => {
    setShowAddModal(true);
    fetchVarkaris();
  };

  const handleCheckboxChange = (e, varkariId) => {
    if (e.target.checked) {
      setSelectedVarkariIds((prev) => [...prev, varkariId]);
    } else {
      setSelectedVarkariIds((prev) => prev.filter((id) => id !== varkariId));
    }
  };

  const handleAddSelectedVarkaris = async () => {
    try {
      // Call your API to update each selected varkari's yatra array
      await Promise.all(
        selectedVarkariIds.map((id) =>
          fetch(`${SummaryApi.addYatraToMultipleVarkaris.url}/${id}`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              yatraId: selectedYatra._id,
              yatraName: selectedYatra.yatraName,
              price: selectedYatra.pricePerPerson,
              booking: "Accepted",
            }),
          })
        )
      );
      alert("Varkaris added successfully!");
      setShowAddModal(false);
      setSelectedVarkariIds([]);
      fetchVarkaris();
    } catch (error) {
      console.error("Error adding varkaris:", error);
      alert("Failed to add varkaris.");
    }
  };

  const handleCompleteYatra = async () => {
    try {
      const response = await fetch(
        `${SummaryApi.updateYatra.url}/${selectedYatra._id}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ status: "complete" }),
        }
      );

      if (response.ok) {
        alert("यात्रा यशस्वीरीत्या पूर्ण झाली!");
        // Optionally refetch the yatra data or update state
      } else {
        alert("अपडेट करताना त्रुटी आली.");
      }
    } catch (error) {
      console.error("Error updating yatra status:", error);
      alert("सर्व्हर त्रुटी आली.");
    }
  };

  return (
    <div>
      {selectedYatra ? (
        <div className="bg-white p-6 rounded-lg shadow-md">
          <button
            onClick={handleBack}
            className="mb-4 text-blue-600 hover:underline"
          >
            ← यादीकडे परत
          </button>
          <h3 className="text-2xl font-bold text-orange-600 mb-2">
            {selectedYatra.yatraName}
          </h3>
          <p className="text-gray-700 mb-1">
            स्थान: {selectedYatra.visitingPlaces || "माहिती उपलब्ध नाही"}
          </p>
          <p className="text-gray-700 mb-1">
            प्रति व्यक्ती दर: ₹
            {selectedYatra.pricePerPerson || "दर उपलब्ध नाही"}
          </p>
          <p className="text-gray-700 mb-4">
            तारीख: {formatDate(selectedYatra.startDate)}
          </p>

          {selectedYatra.status === "upcoming" && (
            <button
              onClick={handleCompleteYatra}
              className="bg-green-600 text-white px-4 py-2 rounded hover:bg-green-700 mb-4"
            >
              यात्रा पूर्ण करा
            </button>
          )}

          <h4 className="text-lg font-semibold mb-2">
            विनंती आलेले वारकरी (Pending):
          </h4>
          {varkaris.length > 0 ? (
            <>
              {/* First Table – Pending Requests */}
              <div className="overflow-x-auto mb-6">
                <table className="min-w-full border border-gray-300">
                  <thead className="bg-gray-100">
                    <tr>
                      <th className="border p-2">Sr. No</th>
                      <th className="border p-2">नाव</th>
                      <th className="border p-2">Mobile No</th>
                      <th className="border p-2">Booking Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    {varkaris
                      .filter((v) =>
                        v.yatra.some(
                          (y) =>
                            (y.yatraId === selectedYatra._id ||
                              y.yatraId?._id === selectedYatra._id) &&
                            y.booking === "Pending"
                        )
                      )
                      .map((varkari, index) => {
                        const currentYatra = varkari.yatra.find(
                          (y) =>
                            y.yatraId === selectedYatra._id ||
                            y.yatraId?._id === selectedYatra._id
                        );

                        return (
                          <tr key={varkari._id}>
                            <td className="border p-2 text-center">
                              {index + 1}
                            </td>
                            <td className="border p-2">{varkari.name}</td>
                            <td className="border p-2">{varkari.mobileNo}</td>
                            <td className="border p-2">
                              {currentYatra?.booking}
                              <button
                                className="ml-2 px-2 py-1 text-sm text-white bg-green-600 hover:bg-green-700 rounded"
                                onClick={async () => {
                                  try {
                                    const res = await fetch(
                                      SummaryApi.updateBookingStatus.url,
                                      {
                                        method: "PUT",
                                        headers: {
                                          "Content-Type": "application/json",
                                        },
                                        body: JSON.stringify({
                                          varkariId: varkari._id,
                                          yatraId: selectedYatra._id,
                                          bookingStatus: "Accepted",
                                        }),
                                      }
                                    );
                                    const result = await res.json();

                                    if (res.ok) {
                                      setVarkaris((prev) =>
                                        prev.map((v) =>
                                          v._id === varkari._id
                                            ? {
                                                ...v,
                                                yatra: v.yatra.map((y) =>
                                                  y.yatraId ===
                                                    selectedYatra._id ||
                                                  y.yatraId?._id ===
                                                    selectedYatra._id
                                                    ? {
                                                        ...y,
                                                        booking: "Accepted",
                                                      }
                                                    : y
                                                ),
                                              }
                                            : v
                                        )
                                      );
                                    } else {
                                      alert("अयशस्वी: " + result.message);
                                    }
                                  } catch (error) {
                                    alert("त्रुटी: " + error.message);
                                  }
                                }}
                              >
                                Accept
                              </button>
                              <button
                                onClick={() =>
                                  handleRemoveVarkari(
                                    varkari._id,
                                    currentYatra?.yatraId
                                  )
                                }
                                className="ml-2 px-2 py-1 text-sm text-white bg-red-600 hover:bg-red-700 rounded"
                              >
                                Decline
                              </button>
                            </td>
                          </tr>
                        );
                      })}
                  </tbody>
                </table>
              </div>

              {/* Second Table – Accepted */}
              <h4 className="text-lg font-semibold mb-2">
                निश्चित वारकरी (Accepted):
              </h4>
              <div className="overflow-x-auto">
                <table className="min-w-full border border-gray-300">
                  <thead className="bg-gray-100">
                    <tr>
                      <th className="border p-2">क्रमांक</th>
                      <th className="border p-2">आधार कार्ड नंबर</th>
                      <th className="border p-2">नाव</th>
                      <th className="border p-2">मोबाइल क्रमांक</th>
                      <th className="border p-2">रक्कम</th>
                      <th className="border p-2">जमा रक्कम</th>
                      <th className="border p-2">बाकी रक्कम</th>
                      <th className="border p-2">काढा</th>
                    </tr>
                  </thead>
                  <tbody>
                    {varkaris
                      .filter((v) =>
                        v.yatra.some(
                          (y) =>
                            (y.yatraId === selectedYatra._id ||
                              y.yatraId?._id === selectedYatra._id) &&
                            y.booking === "Accepted"
                        )
                      )
                      .map((varkari) => {
                        const currentYatra = varkari.yatra.find(
                          (y) =>
                            y.yatraId === selectedYatra._id ||
                            y.yatraId?._id === selectedYatra._id
                        );

                        const price = currentYatra?.price ?? 0;
                        const paid = currentYatra?.paidAmount ?? 0;
                        const baki = price - paid;

                        return { varkari, price, paid, baki, currentYatra };
                      })
                      .sort((a, b) => {
                        // Show baki > 0 first, then baki == 0
                        if (a.baki === 0 && b.baki !== 0) return 1;
                        if (a.baki !== 0 && b.baki === 0) return -1;
                        return 0;
                      })
                      .map(
                        (
                          { varkari, price, paid, baki, currentYatra },
                          index
                        ) => (
                          <tr key={varkari._id}>
                            <td className="border p-2 text-center">
                              {index + 1}
                            </td>
                            <td className="border p-2">
                              {varkari.aadharCardNo}
                            </td>
                            <td
                              className={`border p-2 font-semibold ${
                                baki === 0 ? "text-green-600" : "text-red-600"
                              }`}
                            >
                              {varkari.name}
                            </td>
                            <td className="border p-2">{varkari.mobileNo}</td>
                            <td className="border p-2 text-right">₹{price}</td>
                            <td className="border p-2 text-right">
                              {editIndex === index ? (
                                <div className="flex items-center gap-2">
                                  <input
                                    type="number"
                                    value={newAmount}
                                    onWheel={(e) => e.target.blur()}
                                    onChange={(e) =>
                                      setNewAmount(e.target.value)
                                    }
                                    className="w-20 border px-1 text-right"
                                  />
                                  <button
                                    onClick={() =>
                                      handleSaveAmount(
                                        varkari._id,
                                        currentYatra?.yatraId,
                                        newAmount
                                      )
                                    }
                                    className="text-green-600"
                                  >
                                    Save
                                  </button>
                                </div>
                              ) : (
                                <div className="flex justify-between items-center">
                                  ₹{paid}
                                  <button
                                    onClick={() => {
                                      setEditIndex(index);
                                      setNewAmount(paid ? paid.toString() : "");
                                    }}
                                    className="ml-2 text-blue-600"
                                  >
                                    <Pencil size={16} />
                                  </button>
                                </div>
                              )}
                            </td>
                            <td
                              className={`border p-2 text-right ${
                                baki > 0
                                  ? "text-red-600 font-semibold"
                                  : " text-green-600"
                              }`}
                            >
                              ₹{baki}
                            </td>
                            <td className="border p-2 text-center">
                              <button
                                onClick={() =>
                                  handleRemoveVarkari(
                                    varkari._id,
                                    currentYatra?.yatraId
                                  )
                                }
                                className="text-red-600 hover:text-red-800"
                              >
                                Remove
                              </button>
                            </td>
                          </tr>
                        )
                      )}
                  </tbody>
                </table>
              </div>

              <button
                onClick={openModal}
                className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
              >
                Show Varkaris
              </button>

              {showAddModal && (
                <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-40 z-50">
                  <div className="bg-white p-6 rounded-lg shadow-lg w-full max-w-xl max-h-[80vh] overflow-y-auto relative">
                    <button
                      onClick={() => setShowAddModal(false)}
                      className="absolute top-2 right-2 text-gray-600 hover:text-red-600"
                    >
                      ✕
                    </button>

                    <h2 className="text-xl font-semibold mb-4">All Varkaris</h2>

                    {/* ✅ Add Button */}
                    <button
                      onClick={handleAddSelectedVarkaris}
                      className="mb-4 bg-green-600 text-white px-4 py-2 rounded hover:bg-green-700"
                    >
                      Add Selected
                    </button>

                    {loading ? (
                      <p>Loading...</p>
                    ) : allvarkaris.length > 0 ? (
                      <ul className="space-y-2">
                        {allvarkaris
                          .filter(
                            (varkari) =>
                              !varkari.yatra?.some(
                                (y) =>
                                  y.yatraId === selectedYatra._id ||
                                  y.yatraId?._id === selectedYatra._id
                              )
                          )
                          .map((varkari, index) => (
                            <li
                              key={index}
                              className="border p-2 rounded shadow-sm flex items-center gap-2"
                            >
                              <input
                                type="checkbox"
                                value={varkari._id}
                                checked={selectedVarkariIds.includes(
                                  varkari._id
                                )}
                                onChange={(e) =>
                                  handleCheckboxChange(e, varkari._id)
                                }
                              />
                              <div>
                                <strong>Name:</strong> {varkari.name} <br />
                                <strong>Mobile:</strong> {varkari.mobileNo}
                              </div>
                            </li>
                          ))}
                      </ul>
                    ) : (
                      <p>No Varkaris found.</p>
                    )}
                  </div>
                </div>
              )}

              <div className="flex justify-end mt-6">
                <button
                  onClick={() => setShowVarkariModal(true)}
                  className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded shadow"
                >
                  नवीन वारकरी जोडा
                </button>
              </div>

              {showVarkariModal && (
                <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
                  <div className="bg-white rounded-lg shadow-lg p-6 w-full max-w-xl relative">
                    <h2 className="text-xl font-bold mb-4 text-orange-600">
                      नवीन वारकरी जोडा
                    </h2>

                    <form
                      onSubmit={(e) => {
                        e.preventDefault();
                        handleCreateVarkari();
                      }}
                      className="space-y-4"
                    >
                      <div>
                        <label className="block font-semibold">नाव:</label>
                        <input
                          type="text"
                          value={newVarkari.name}
                          onChange={(e) =>
                            setNewVarkari({
                              ...newVarkari,
                              name: e.target.value,
                            })
                          }
                          className="w-full border px-3 py-1 rounded"
                          required
                        />
                      </div>

                      <div>
                        <label className="block font-semibold">वय:</label>
                        <input
                          type="number"
                          value={newVarkari.age}
                          onWheel={(e) => e.target.blur()}
                          onChange={(e) =>
                            setNewVarkari({
                              ...newVarkari,
                              age: e.target.value,
                            })
                          }
                          className="w-full border px-3 py-1 rounded"
                          required
                        />
                      </div>

                      <div>
                        <label className="block font-semibold">
                          मोबाइल नंबर:
                        </label>
                        <input
                          type="text"
                          value={newVarkari.mobileNo}
                          onWheel={(e) => e.target.blur()}
                          onChange={(e) =>
                            setNewVarkari({
                              ...newVarkari,
                              mobileNo: e.target.value,
                            })
                          }
                          className="w-full border px-3 py-1 rounded"
                          required
                        />
                      </div>

                      <div>
                        <label className="block font-semibold">
                          आधार कार्ड नंबर:
                        </label>
                        <input
                          type="text"
                          value={newVarkari.aadharCardNo}
                          onWheel={(e) => e.target.blur()}
                          onChange={(e) =>
                            setNewVarkari({
                              ...newVarkari,
                              aadharCardNo: e.target.value,
                            })
                          }
                          className="w-full border px-3 py-1 rounded"
                        />
                      </div>

                      <div>
                        <label className="block font-semibold">पत्ता:</label>
                        <textarea
                          value={newVarkari.address}
                          onChange={(e) =>
                            setNewVarkari({
                              ...newVarkari,
                              address: e.target.value,
                            })
                          }
                          className="w-full border px-3 py-1 rounded"
                          required
                        />
                      </div>

                      <div className="flex items-center gap-2">
                        <input
                          type="checkbox"
                          checked={newVarkari.apang}
                          onChange={(e) =>
                            setNewVarkari({
                              ...newVarkari,
                              apang: e.target.checked,
                            })
                          }
                        />
                        <label>अपंग आहात का?</label>
                      </div>

                      <div className="flex items-center gap-2">
                        <input
                          type="checkbox"
                          checked={newVarkari.agreedTerms}
                          onChange={(e) =>
                            setNewVarkari({
                              ...newVarkari,
                              agreedTerms: e.target.checked,
                            })
                          }
                          required
                        />
                        <label>मी अटी व शर्ती स्वीकारतो.</label>
                      </div>

                      <div className="flex justify-end gap-4 pt-2">
                        <button
                          type="button"
                          className="text-gray-600 hover:text-gray-800"
                          onClick={() => setShowVarkariModal(false)}
                        >
                          Cancel
                        </button>
                        <button
                          type="submit"
                          className="bg-green-600 hover:bg-green-700 text-white px-4 py-2 rounded"
                        >
                          जतन करा
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              )}

              <div className="mt-4 flex justify-end gap-8 text-right text-lg font-semibold">
                <div>एकूण रक्कम: ₹{totalPrice}</div>
                <div>एकूण जमा रक्कम: ₹{totalPaid}</div>
                <div>एकूण बाकी रक्कम: ₹{totalBaki}</div>
              </div>
              <div className="mt-6 w-full flex justify-center md:justify-end">
                <div className="mt-6  flex flex-col gap-4 justify-end">
                  <div className="flex gap-2">
                    <label className="block mb-1 font-semibold w-32">
                      रेल्वे तिकीट खर्च :
                    </label>
                    <input
                      type="number"
                      className="w-auto border-b"
                      value={railwayTicket}
                      onWheel={(e) => e.target.blur()}
                      onChange={(e) => setRailwayTicket(Number(e.target.value))}
                    />
                  </div>
                  <div className="flex gap-2">
                    <label className="block mb-1 font-semibold w-32">
                      बस तिकीट खर्च :
                    </label>
                    <input
                      type="number"
                      className="w-auto border-b"
                      value={busTicket}
                      onWheel={(e) => e.target.blur()}
                      onChange={(e) => setBusTicket(Number(e.target.value))}
                    />
                  </div>
                  <div className="flex gap-2">
                    <label className="block mb-1 font-semibold w-32">
                      किराणा :
                    </label>
                    <input
                      type="number"
                      className="w-auto border-b"
                      value={kirana}
                      onWheel={(e) => e.target.blur()}
                      onChange={(e) => setKirana(Number(e.target.value))}
                    />
                  </div>
                  <div className="flex gap-2">
                    <label className="block mb-1 font-semibold w-32">
                      रूम / हॉटेल खर्च :
                    </label>
                    <input
                      type="number"
                      className="w-auto border-b"
                      value={roomhotel}
                      onWheel={(e) => e.target.blur()}
                      onChange={(e) => setroomhotel(Number(e.target.value))}
                    />
                  </div>
                  <div className="flex gap-2">
                    <label className="block mb-1 font-semibold w-32">
                      इतर खर्च :
                    </label>
                    <input
                      type="number"
                      className="w-auto border-b"
                      value={otherexpense}
                      onWheel={(e) => e.target.blur()}
                      onChange={(e) => setotherexpense(Number(e.target.value))}
                    />
                  </div>
                  <p className="text-lg font-bold text-green-700 mt-4">
                    नफा (Profit): ₹
                    {selectedYatra.financialSummary?.profit ?? "उपलब्ध नाही"}
                  </p>

                  <div className="mt-6 flex justify-end">
                    <button
                      onClick={saveFinancialData}
                      className="px-6 py-2 bg-green-600 text-white rounded hover:bg-green-700"
                    >
                      आर्थिक सारांश जतन करा
                    </button>
                  </div>
                </div>
              </div>
            </>
          ) : (
            <p className="text-gray-500">कोणताही वारकरी आढळला नाही.</p>
          )}
        </div>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
  {yatras.filter((yatra) => yatra.status === "complete").length > 0 ? (
    yatras
      .filter((yatra) => yatra.status === "complete")
      .map((yatra) => (
        <div
          key={yatra._id}
          onClick={() => handleClick(yatra)}
          className="bg-white rounded-lg shadow-md p-4 hover:shadow-lg transition cursor-pointer"
        >
          <h3 className="text-xl font-semibold text-orange-600">
            {yatra.yatraName}
          </h3>
          <p className="text-gray-600">
            तारीख: {formatDate(yatra.startDate)}
          </p>
        </div>
      ))
  ) : (
    <p>कोणतीही यात्रा उपलब्ध नाही.</p>
  )}
</div>

      )}
    </div>
  );
}

export default YatraList;
